import { Circle, CircleOutlined, CropLandscape, CropPortrait, CropSquare, Interests } from '@mui/icons-material'
import { Button, ButtonGroup, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'

const Shape = ({ setShape, shape }) => {
  const [flagShape, setFlagShape] = useState("")

  const handleFlagShape = (value) => {
    if (value !== flagShape) {
      setFlagShape(value)
      setShape(value)
    } else {
      setFlagShape("")
      setShape("")
    }
  } 

  useEffect(() => {
    if(shape === null) {
      setFlagShape("")
    }
}, [shape])

  return (
    <div>
      <ButtonGroup color='primary' variant="text">
        <IconButton 
          size="large" 
          title='Square shape' 
          sx={{ backgroundColor: flagShape === "Square" ? '#eeeeee' : "", "&:hover": { backgroundColor: "#eeeeee" }, color: '#333E48' }}
          onClick={() => handleFlagShape("Square")}
        >
          <CropSquare fontSize="inherit" />
        </IconButton>
        <IconButton 
          size="large" 
          title='Rectangular portrait shape'
          sx={{ backgroundColor: flagShape === "Rectangular - Portrait" ? '#eeeeee' : "", "&:hover": { backgroundColor: "#eeeeee" }, color: '#333E48' }}
          onClick={() => handleFlagShape("Rectangular - Portrait")}
        >
          <CropPortrait fontSize="inherit" />
        </IconButton>
        <IconButton 
          size="large" 
          title='Rectangular landscape shape'
          sx={{ backgroundColor: flagShape === "Rectangular - Landscape" ? '#eeeeee' : "", "&:hover": { backgroundColor: "#eeeeee" }, color: '#333E48' }}
          onClick={() => handleFlagShape("Rectangular - Landscape")}
        >
          <CropLandscape fontSize="inherit" />
        </IconButton>
        <IconButton 
          size="large" 
          title='Circle shape'
          sx={{ backgroundColor: flagShape === "Round" ? '#eeeeee' : "", "&:hover": { backgroundColor: "#eeeeee" }, color: '#333E48' }}
          onClick={() => handleFlagShape("Round")}
        >
          <CircleOutlined fontSize="inherit" />
        </IconButton>
        <IconButton 
          size="large" 
          title='Other shape'
          sx={{ backgroundColor: flagShape === "Other" ? '#eeeeee' : "", "&:hover": { backgroundColor: "#eeeeee" }, color: '#333E48' }}
          onClick={() => handleFlagShape("Other")}
        >
          <Interests fontSize="inherit" />
        </IconButton>
      </ButtonGroup>
    </div>
  )
}

export default Shape